import { SpinTheWheelResponse } from "../../types/rewards";

export const spinTheWheelModel = (
  response: SpinTheWheelResponse
): SpinTheWheelResponse => response;
